// Brand color + 3-letter abbreviation per EPL club (2026/27).
// Used to render a compact badge next to nicknames.
export const TEAM_META = {
  "Arsenal":                { abbr: "ARS", color: "#EF0107", text: "#FFFFFF" },
  "Aston Villa":            { abbr: "AVL", color: "#670E36", text: "#95BFE5" },
  "Bournemouth":            { abbr: "BOU", color: "#DA291C", text: "#000000" },
  "Brentford":              { abbr: "BRE", color: "#E30613", text: "#FFFFFF" },
  "Brighton & Hove Albion": { abbr: "BHA", color: "#0057B8", text: "#FFCD00" },
  "Chelsea":                { abbr: "CHE", color: "#034694", text: "#FFFFFF" },
  "Coventry City":          { abbr: "COV", color: "#4B92DB", text: "#FFFFFF" },
  "Crystal Palace":         { abbr: "CRY", color: "#1B458F", text: "#C4122E" },
  "Everton":                { abbr: "EVE", color: "#003399", text: "#FFFFFF" },
  "Fulham":                 { abbr: "FUL", color: "#000000", text: "#CC0000" },
  "Hull City AFC":          { abbr: "HUL", color: "#F5A12D", text: "#000000" },
  "Ipswich Town":           { abbr: "IPS", color: "#0044A9", text: "#FFFFFF" },
  "Leeds United":           { abbr: "LEE", color: "#FFFFFF", text: "#1D4189" },
  "Liverpool":              { abbr: "LIV", color: "#C8102E", text: "#F6EB61" },
  "Manchester City":        { abbr: "MCI", color: "#6CABDD", text: "#1C2C5B" },
  "Manchester United":      { abbr: "MUN", color: "#DA291C", text: "#FBE122" },
  "Newcastle United":       { abbr: "NEW", color: "#241F20", text: "#FFFFFF" },
  "Nottingham Forest":      { abbr: "NFO", color: "#DD0000", text: "#FFFFFF" },
  "Sunderland AFC":         { abbr: "SUN", color: "#EB172B", text: "#FFFFFF" },
  "Tottenham Hotspur":      { abbr: "TOT", color: "#132257", text: "#FFFFFF" },
};

export const teamMeta = (name) => TEAM_META[name] || null;

export const teamShort = (name) => {
  const meta = TEAM_META[name];
  if (meta) return meta.abbr;
  // fallback for unexpected/legacy names — first 3 letters uppercased
  return (name || "").replace(/[^a-zA-Z]/g, "").slice(0, 3).toUpperCase();
};
